import type { CirculoConfig, CirculoPresetId } from './types';

export const CIRCULO_PRESET_IDS = ['cima', 'baixo'] as const;

export function isCirculoPresetId(value: unknown): value is CirculoPresetId {
  return typeof value === 'string' && (CIRCULO_PRESET_IDS as readonly string[]).includes(value);
}

export function resolveCirculoPreset(config: { preset?: string | null }): CirculoPresetId {
  return isCirculoPresetId(config.preset) ? config.preset : 'baixo';
}

export function circuloCurveFromLayout(
  postLayout: { kind?: string; preset?: string | null } | null | undefined,
): { position: CirculoPresetId } | undefined {
  if (postLayout?.kind !== 'circulo') return undefined;
  return { position: resolveCirculoPreset(postLayout) };
}

const BACKGROUND_KEYS = [
  'backgroundColor', 'backgroundUrl', 'backgroundMedia',
  'fillerUrl', 'fillerUrls', 'fillerFits', 'fillerPositions', 'fillerSpeed', 'fillerRandomize',
] as const;

export function circuloConfigForPreset(
  preset: CirculoPresetId,
  previous?: CirculoConfig | null,
): CirculoConfig {
  const next: CirculoConfig = { kind: 'circulo', preset };
  if (!previous || previous.kind !== 'circulo') return next;
  for (const key of BACKGROUND_KEYS) {
    const value = previous[key];
    if (value !== undefined) (next as unknown as Record<string, unknown>)[key] = value;
  }
  return next;
}
